module.exports = __webpack_public_path__ + "static/media/search.93765079.svg";